import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { ActiveDepartmentState, ActiveDepartmentStore } from './types';
import {
    checkDevEnv,
    createSingleKeySetter,
    type SingleKeySetter,
} from '../utils';

const initialState: ActiveDepartmentState = {
    activeDepartmentId: null,
    activeDepartment: null,
    isDepartmentReadOnly: true, // TODO: Set up disabling in planners
    isHydrated: false,
};

export const useActiveDepartmentStore = create<ActiveDepartmentStore>()(
    devtools(
        persist(
            (set) => {
                const createActiveDepartmentSetter = (
                    key: keyof ActiveDepartmentState,
                ): SingleKeySetter<
                    ActiveDepartmentStore,
                    keyof ActiveDepartmentState
                > => createSingleKeySetter(set, key, 'activeDepartment');

                return {
                    ...initialState,

                    setActiveDepartmentId:
                        createActiveDepartmentSetter('activeDepartmentId'),

                    setActiveDepartment:
                        createActiveDepartmentSetter('activeDepartment'),

                    setIsDepartmentReadOnly: createActiveDepartmentSetter(
                        'isDepartmentReadOnly',
                    ),

                    setIsHydrated: createActiveDepartmentSetter('isHydrated'),
                };
            },
            {
                // Kept from the store's previous 'departmentStore' name so
                // existing persisted state (isDepartmentReadOnly) survives.
                name: 'dynoweb-department-store',
                partialize: (state) => ({
                    isDepartmentReadOnly: state.isDepartmentReadOnly,
                }),
                onRehydrateStorage:
                    (): ((state?: ActiveDepartmentStore) => void) =>
                    (state): void => {
                        state?.setIsHydrated(true);
                    },
            },
        ),
        {
            name: 'ActiveDepartmentStore',
            enabled: checkDevEnv(),
            store: 'ActiveDepartmentStore',
        },
    ),
);
